import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { GelContentContainer, HeroSearch, Loading } from "cw-styleguide-react";
import SearchFilterForm from "../components/SearchFilterForm";
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import {route} from "../../../routes";
import Helmet from 'react-helmet';

class SearchView extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('local:view.search.title')}</title>
        </Helmet>

        <h1 className={'sr-only'}>{this.props.t('local:view.search.title')}</h1>
        <HeroSearch>
          <SearchFilterForm {...this.props} />
        </HeroSearch>
        <GelContentContainer>
          {this.props.settingsLoaded
            ? <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
            : <Loading  text={this.props.t('styleguide:forms.loading')} />
          }
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withTranslation('styleguide')(SearchView);
